module.exports = {
  name: '红树森林',
  shortName: '红树',
  logo: 'https://successfe.oss-cn-hangzhou.aliyuncs.com/static/ukew_hssl_logo_new.svg',
  loginImg: 'https://successfe.oss-cn-hangzhou.aliyuncs.com/static/hssl-login-bg.png',
}
